import React from "react";
import { useState, useEffect, Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import gsap from "gsap";
import SplitType from "split-type";
import { useProgress } from "@react-three/drei";
import Scene from "../Scene";

export const TextShader = ({fragShader}) => {
  const { progress } = useProgress();
  
  return (
    <>
      <div className="relative w-screen md:h-screen h-[100dvh]">
        <Canvas
          dpr={[1, 2]}
          gl={{
            antialias: true,
            preserveDrawingBuffer: true,
          }}
          camera={{
            fov: 55,
            near: 0.1,
            far: 200,
          }}
        >
          <Suspense>
            <Scene fragShader={fragShader} />
          </Suspense>
        </Canvas>
      </div>
    </>
  );
};
